import { render } from "./RechercheTerm.vue?vue&type=template&id=b2de136a&scoped=true&ts=true"
import script from "./RechercheTerm.vue?vue&type=script&lang=ts"
export * from "./RechercheTerm.vue?vue&type=script&lang=ts"

import "./RechercheTerm.vue?vue&type=style&index=0&id=b2de136a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2de136a"]])

export default __exports__